import { useState } from 'react';
import styled from 'styled-components';
import { useCart } from 'context/CartContext';
import { colors } from 'styles/variables';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CartServices } from '@services';

const Quanity = ({ productID, avalaibleStock, addedPackCount, preOrder }) => {
    const stocks = Array.from({ length: avalaibleStock }, (_, i) => i + 1);
    const requestStock = [12, 15, 18, 21, 24, 27, 30];
    const queryClient = useQueryClient();
    const { basketHash, currentUser } = useCart();

    const addToCartMutation = useMutation({
        mutationFn: CartServices.addToCart,
        onSuccess: () => {
            queryClient.invalidateQueries(['getCart']);
        },
    });

    const [selectedPackAmount, setSelectedPackAmount] = useState(
        addedPackCount,
    );

    const currentStock = preOrder ? requestStock : stocks;

    const onAmountChange = (e) => {
        const amount = Number(e.target.value);
        setSelectedPackAmount(amount);
        addToCartMutation.mutate({
            products: [
                { productId: productID, quantity: amount, overwrite: true },
            ],
            token: currentUser?.token,
            basketHash,
        });
    };

    return (
        <QuanityWrapper>
            <SelectBox onChange={onAmountChange}>
                {currentStock.map((i) => (
                    <option
                        key={i}
                        value={i}
                        selected={selectedPackAmount === i}
                    >
                        {i} Pack, {i * 3} Units
                    </option>
                ))}
            </SelectBox>
        </QuanityWrapper>
    );
};

const SelectBox = styled.select`
    font-family: var(--futura-font);
    font-weight: 500;
    font-size: 10px;
    width: 130px;
    outline: none;
    border: 1px solid #e4e4e4;
    color: ${colors.dark};
    padding: 10px;
    option {
        font-family: 'Futura Now Headline Medium';
        font-size: 10px;
        letter-spacing: 1px;
    }
`;

const QuanityWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    height: 34px;
    width: max-content;
    @media (max-width: 720px) {
        margin-left: 60px;
    }
    span {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-family: 'Futura Now Headline Bold';
        border-top: solid 1px ${colors.borderGray};
        border-bottom: solid 1px ${colors.borderGray};
    }
    button {
        width: 34px;
        height: 34px;
        background-color: ${colors.disabled};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        border: none;
        cursor: pointer;
        border: solid 1px ${colors.borderGray};
        :disabled {
            div::before,
            div::after {
                background: ${colors.gray};
            }
        }
    }
`;

export default Quanity;
